// 星图图片专用线路；不能作为文字或视觉理解模型使用。
export const ASTRAFLOW_IMAGE_QUALITY_OPTIONS = Object.freeze([
  { value: 'low', label: '低质量' },
  { value: 'medium', label: '中等质量' },
  { value: 'high', label: '高质量' },
  { value: 'xhigh', label: '超高质量' },
  { value: 'max', label: '最高质量' },
]);

export const DEFAULT_ASTRAFLOW_IMAGE_QUALITY = 'high';

export const normalizeAstraflowImageQuality = (quality) => {
  const normalized = String(quality || '').trim().toLowerCase();
  return ASTRAFLOW_IMAGE_QUALITY_OPTIONS.some((option) => option.value === normalized)
    ? normalized
    : DEFAULT_ASTRAFLOW_IMAGE_QUALITY;
};

export const ASTRAFLOW_IMAGE_MODELS = Object.freeze([
  { id: 'astraflow_image_flare', provider: 'ASTRAFLOW_IMAGE_FLARE', model: 'gpt-image-2.5-flare', label: 'Image-2.5_线路3 · Flare' },
  { id: 'astraflow_image_sunburst', provider: 'ASTRAFLOW_IMAGE_SUNBURST', model: 'gpt-image-2.5-sunburst', label: 'Image-2.5_线路3 · Sunburst' },
]);

export const isAstraflowImageProvider = (provider) => {
  const id = String(provider || '').trim().toLowerCase();
  return ASTRAFLOW_IMAGE_MODELS.some((item) => item.id === id);
};
